import type { Option } from "@/Components/UI/TcSelect.vue";
import { viewMonthAgenda, viewWeek, viewDay } from "@schedule-x/calendar";

export const WEEK_HOUR_HEIGHT = 50;

export const EVENT_DATE_FORMAT = "yyyy-MM-dd HH:mm";
export const SELECTED_DATE_FORMAT = "yyyy-MM-dd";

export enum CALENDAR_VIEW {
  "DAY" = viewDay.name as unknown as number,
  "WEEK" = viewWeek.name as unknown as number,
  "MONTH" = viewMonthAgenda.name as unknown as number,
  "LIST" = "LIST",
}

export const CALENDAR_VIEW_OPTIONS = [
  { icon: "Calendar", label: "day", value: CALENDAR_VIEW.DAY },
  { icon: "Week", label: "week", value: CALENDAR_VIEW.WEEK },
  { icon: "Calendar", label: "month", value: CALENDAR_VIEW.MONTH },
] as Option[];
